// This file is only a template for services.  Copy and paste this to your application's service .ts file and start off from there
// Rename all things with KnowledgeBook.
// Naming convention for services is "[App Name]Services.ts" i.e. UsersServices.ts, EntitlementServices.ts

import * as Inovx from '@shared';
import assign from 'object-assign';
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var url = `${UrlUtilities.getApiUrl()}/FacilityApi/api/Setting`;

var SettingServices: ISettingService = assign({}, Inovx.Shared.Flux.BaseService, {
    getSettings: function (successCallback: (retData: IFacilitySettings) => void, errorCallback: IErrorCallback, ignoreDefaultError?: boolean) {

        this.get(`${url}/GetApplicationSetting`,
                    null,
                    (retData: any) => {
                        successCallback(retData);
                    },
                    (error: any) => {
                        if (!ignoreDefaultError) {
                            this.handleWebApiError(error);
                        }
                        errorCallback(error);
                    }
                );
    },
    setSettings: function (settings: IFacilitySettings, successCallback: () => void, errorCallback: IErrorCallback) {

        this.post(`${url}/SetApplicationSetting`,
                    {settings},
                    (retData: any) => {
                        successCallback();
                    },
                    (error: any) => {
                        
                        this.handleWebApiError(error);
                        errorCallback(error);
                    }
                );
    }
});

export default SettingServices;